import React from "react";
import Apps from "../../Apps";

const MarketplacePage = ({selectedCPView, addOrEditAccess}) => {
  return (
    <Apps
      closePortalowner={selectedCPView}
      addOrEditAccess={addOrEditAccess}
    />
  );
};

export default MarketplacePage;
